'use strict';

import GenericTableData from './GenericTableData';

// ABR Code Module Event Bus.
let ABRCodeData = GenericTableData.getTableDataBus('ABR_CODE', 'abr_codes');
let fullABRList;

ABRCodeData.populateABRList = (forceUpdate) => {
  if (forceUpdate || !fullABRList) {
    ABRCodeData.getAllRecords({
      fields: 'abr_code,description',
    }).then(({ records }) => {
      fullABRList = [...records];
      ABRCodeData.notifyListeners('ALL_ABR_CODES_LOADED', fullABRList);
      return fullABRList;
    });
  }
};

ABRCodeData.getAllABRCodes = function () {
  return fullABRList;
};

ABRCodeData.updateABRCode = (recordData) => {
  return ABRCodeData.updateRecord(recordData).then((results) => {
    ABRCodeData.populateABRList(true);
    return results;
  });
};

ABRCodeData.createABRCode = (recordData) => {
  return ABRCodeData.createRecord(recordData).then((results) => {
    ABRCodeData.populateABRList(true);
    return results;
  });
};

ABRCodeData.deleteABRCode = (abrCode) => {
  return ABRCodeData.deleteRecordsWhere({ abr_code: abrCode }).then(
    (results) => {
      ABRCodeData.populateABRList(true);
      return results;
    },
  );
};

ABRCodeData.getABRCodeList = function () {
  return ABRCodeData.getAllRecords({
    fields: 'abr_code,description',
    busListenerActionName: 'ABR_CODE_LIST_LOADED',
  });
};

export default ABRCodeData;
